import { CreateMeetingCommand } from "@aws-sdk/client-chime-sdk-meetings";
import { v4 as uuidv4 } from "uuid";
import { getChimeClient } from "./get-chime-client";
import ToasterWithMessage from "../../components/toaster";

const { error: errorToast } = ToasterWithMessage();

export const createChimeMeeting = async () => {
  try {
    const chimeClient = await getChimeClient();

    // Generate a unique meeting ID
    const meetingId = uuidv4();

    const createMeetingInput = {
      MediaRegion: await chimeClient.config.region(),
      ExternalMeetingId: meetingId,
    };

    // Send the command to create a meeting
    const command = new CreateMeetingCommand(createMeetingInput);
    const meetingResponse = await chimeClient.send(command);
    console.log("[Log] Meeting created successfully:", meetingResponse);

    // Check if meeting ID is present in the response
    if (!meetingResponse.Meeting || !meetingResponse.Meeting.MeetingId) {
      errorToast("Meeting ID is missing in the response.");
      throw new Error("Meeting ID is missing in the response.");
    }

    return meetingResponse;
  } catch (error: any) {
    if(error?.message?.includes('Meeting') && error?.message?.includes('not found')) {
      errorToast("Meeting not found");
    }else{
      errorToast(error.message);
    }
    console.error("[Log] Failed to create meeting:", error.message || error);
  }
};
